import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {wordSelectId} from "../../defines/client.const";
import {SimpleWord} from "../../models/simple-word.model";

@Component({
  selector: 'app-word-item',
  templateUrl: './word-item.component.html',
  styleUrls: ['./word-item.component.scss']
})
export class WordItemComponent implements AfterViewInit {
  @Input() word: SimpleWord;
  @Input() select = false;
  @Input() showLevel = true;
  @Output() openWordHelp = new EventEmitter<void>();

  protected readonly wordSelectId = wordSelectId;
  protected readonly Array = Array;

  constructor(
    private elRef: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    this.word.offsetTop = this.elRef.nativeElement.offsetTop;
  }

  protected get briefMeaning(): string {
    return this.word?.GetBriefMeaning() ?? '';
  }
}
